"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignUpValidationSchema = void 0;
const Yup = __importStar(require("yup"));
const REQUIRED_FIELD = 'Este campo é obrigatório';
const MUST_BE_VALID_EMAIL = 'Este campo deve ser um e-mail válido';
exports.SignUpValidationSchema = Yup.object({
    name: Yup.string().required(REQUIRED_FIELD),
    email: Yup.string().email(MUST_BE_VALID_EMAIL).required(REQUIRED_FIELD),
    cpf: Yup.string().test({
        message: 'Deve ser um CPF válido',
        test: (value) => {
            const cpf = (value === null || value === void 0 ? void 0 : value.replace(/[^\d]+/g, '')) || '';
            if (cpf == '') {
                return false;
            }
            if (cpf.length != 11 ||
                cpf == "00000000000" ||
                cpf == "11111111111" ||
                cpf == "22222222222" ||
                cpf == "33333333333" ||
                cpf == "44444444444" ||
                cpf == "55555555555" ||
                cpf == "66666666666" ||
                cpf == "77777777777" ||
                cpf == "88888888888" ||
                cpf == "99999999999")
                return false;
            let add = 0;
            for (let i = 0; i < 9; i++)
                add += parseInt(cpf.charAt(i)) * (10 - i);
            let rev = 11 - (add % 11);
            if (rev == 10 || rev == 11)
                rev = 0;
            if (rev != parseInt(cpf.charAt(9)))
                return false;
            add = 0;
            for (let i = 0; i < 10; i++)
                add += parseInt(cpf.charAt(i)) * (11 - i);
            rev = 11 - (add % 11);
            if (rev == 10 || rev == 11)
                rev = 0;
            if (rev != parseInt(cpf.charAt(10)))
                return false;
            return true;
        }
    }).required(REQUIRED_FIELD),
    whatsapp: Yup.string().required(REQUIRED_FIELD),
    telegram: Yup.string().required(REQUIRED_FIELD),
    cep: Yup.string().test({
        message: 'Deve ser um CEP válido',
        test: (value) => {
            const cep = value === null || value === void 0 ? void 0 : value.replace(/\D/ig, '');
            return (cep === null || cep === void 0 ? void 0 : cep.length) === 8;
        }
    }).required(REQUIRED_FIELD),
    address: Yup.string().required(REQUIRED_FIELD),
    address_number: Yup.string().required(REQUIRED_FIELD),
    phone_number: Yup.string().required(REQUIRED_FIELD),
    complement: Yup.string().optional(),
    city: Yup.string().required(REQUIRED_FIELD),
    state: Yup.string().length(2, 'Use apenas a sigla do estado (Ex.: SP, RJ, SC)').required(REQUIRED_FIELD),
    password: Yup.string()
        .min(8, 'Deve conter no mínimo 8 caracteres')
        .matches(/[a-z]+/, 'Deve conter no mínimo uma letra minúscula')
        .matches(/[A-Z]+/, 'Deve conter no mínimo uma letra maiúscula')
        .matches(/\d+/, 'Deve conter um número')
        .required(REQUIRED_FIELD),
    password_confirmation: Yup.string().oneOf([Yup.ref('password')], 'As senhas devem ser iguais').required(REQUIRED_FIELD),
    neighborhood: Yup.string().required(REQUIRED_FIELD),
});
